/**
 * DOM Identifiers for the Bottom Options Bar
 */
export const BOTTOM_BAR_ID = 'bottom-options-bar'
export const BOTTOM_BAR_OPEN_CLASS = 'bottom-bar-open'
export const BOTTOM_BAR_COLLAPSED_CLASS = 'bottom-bar-collapsed'

/**
 * Event names for controlling the Bottom Options Bar
 */
export const BOTTOM_BAR_COLLAPSE_EVENT = 'bottom-bar-collapse'
